import { Box } from "@chakra-ui/react";
import { createPortal } from "react-dom";
import { PurchaseButton } from "../components/PurchaseButton";
import { STRIPE_FORM_ID } from "../components/StripePayment";

export function StickyPurchaseButton({
  isDisabled,
  loading,
  text,
}: {
  isDisabled: boolean;
  loading: boolean;
  text: string;
}) {
  const portalTarget =
    document.getElementById("gcModalContentContainer") ??
    document.getElementById("gcSlideInMenuContentContainer");
  if (!portalTarget) return null;

  return createPortal(
    <Box
      p="24px"
      borderTop="1px solid"
      borderColor="transparent.white.20"
      background="#141517f2"
      flexShrink={0}
      pointerEvents="auto"
    >
      <PurchaseButton
        isDisabled={isDisabled}
        text={text}
        loading={loading}
        onClick={() => {
          const form = document.getElementById(STRIPE_FORM_ID);
          if (form instanceof HTMLFormElement) {
            form.requestSubmit();
          }
        }}
      />
    </Box>,
    portalTarget,
  );
}
